import {GlobalContext} from "../../GlobalContext";
import {
    Badge,
    Button,
    Card,
    Col,
    Container,
    Form, FormCheck,
    FormControl,
    FormGroup,
    FormLabel,
    Modal,
    Row,
    Table
} from "react-bootstrap";
import {Glyph} from "../common/Glyph";
import React from "react";
import {SpinnerWrapper} from "../common/SpinnerWrapper";
import moment from "moment-timezone";
import {PatientSearch} from "../common/patient/PatientSearch";
import ReferralUploadProviderPicker from "./ReferralUploadProviderPicker";
import ReferralUploadPatientPicker from "./ReferralUploadPatientPicker";
import ReferralUploadCancelModal from "./ReferralUploadCancelModal";
import ReferralUploadSpecialtySection, {limitSpecialtyDetails, visitSubtypeForCategory} from "./ReferralUploadSpecialtySection";
import {withRouter} from "react-router-dom";

class ReferralUpload extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        const jobIdFromUrl = new URLSearchParams(props.location.search).get('jobId');
        this.state = {
            selectedFiles: [],
            validated: false,
            uploading: false,
            jobResults: null,
            patient: {
                id: 0,
                name: "",
                dob: "",
                phoneNumber: "",
                email: "",
                externalId: ""
            },
            provider: {
                id: 0,
                firstName: "",
                lastName: "",
                titleCode: "",
                npi: ""
            },
            group: {
                id: 0,
                name: "",
                addr1: "",
                addr2: "",
                city: "",
                state: "",
                zip: "",
                fax: "",
                email: "",
                phone: ""
            },
            attorney: {
                id: 0,
                firstName: "",
                lastName: "",
                titleCode: "",
                npi: ""
            },
            attorneyGroup: {
                id: 0,
                name: "",
                addr1: "",
                addr2: "",
                city: "",
                state: "",
                zip: "",
                fax: "",
                email: "",
                phone: ""
            },
            showAltProviderModal: false,
            showAltAttorneyModal: false,
            showAltPatientModal: false,
            showUpload: jobIdFromUrl ? false : true,
            jobId: jobIdFromUrl,
            showCancelModal: false,
            posting: false,
            lienDetails: {},
            workersCompDetails: {},
            specialtyInfoIgnored: false,
        };
    }

    componentDidMount() {
        const jobId = this.getJobIdFromUrl();
        if (jobId) {
            this.loadPendingUpload(jobId);
        }
    }

    componentDidUpdate(prevProps) {
        const jobId = this.getJobIdFromUrl();
        const prevJobId = this.getJobIdFromUrl(prevProps);
        if (jobId !== prevJobId) {
            this.reset(() => this.applyJobIdFromUrl(jobId));
        }
    }

    getJobIdFromUrl = (props) =>
        new URLSearchParams((props || this.props).location.search).get('jobId');

    loadPendingUpload = (jobId) => {
        if (!jobId || !this.context.authenticated) {
            return;
        }

        this.context.apiRequest('GET', `/referrals/pendingUploads/${jobId}`)
            .then(resp => {
                if (resp && resp.data) {
                    this.setState({
                        jobId,
                        jobResults: { result: resp.data, jobId }
                    }, this.useSuggestedProviders);
                }
            });
    };

    applyJobIdFromUrl = (jobId) => {
        if (jobId) {
            this.setState({ showUpload: false, jobId }, () => this.loadPendingUpload(jobId));
        } else {
            this.setState({ showUpload: true });
        }
    };

    reset = (callback) =>
        this.setState({
            selectedFiles: [],
            validated: false,
            uploading: false,
            jobResults: null,
            jobId: null,
            patient: {id: 0, name: "", dob: "", phoneNumber: "", email: "", externalId: ""},
            provider: {id: 0, firstName: "", lastName: "", titleCode: "", npi: ""},
            group: {id: 0, name: "", addr1: "", addr2: "", city: "", state: "", zip: "", fax: "", email: "", phone: ""},
            attorney: {id: 0, firstName: "", lastName: "", titleCode: "", npi: ""},
            attorneyGroup: {id: 0, name: "", addr1: "", addr2: "", city: "", state: "", zip: "", fax: "", email: "", phone: ""},
            showAltProviderModal: false,
            showAltAttorneyModal: false,
            showAltPatientModal: false,
            lienDetails: {},
            workersCompDetails: {},
            specialtyInfoIgnored: false,
        }, callback);

    handleFileSelection = (e) => {
        const files = Array.from(e.target.files);
        let newFiles = [...this.state.selectedFiles];
        newFiles.push(...files);
        this.setState({ selectedFiles: newFiles });
    };

    removeFile = (index) => {
        const updatedFiles = this.state.selectedFiles.filter((_, i) => i !== index);
        this.setState({ selectedFiles: updatedFiles });

        // Clear the file input if no files remain
        if (updatedFiles.length === 0) {
            const fileInput = document.getElementById('fileInput');
            if (fileInput) {
                fileInput.value = '';
            }
        }
    };

    handleUpload = () => {
        if (this.state.selectedFiles.length === 0) {
            return;
        }

        this.setState({
                uploading: true,
                validated: false,
                jobResults: null,
                patient: {id: 0, name: "", dob: "", phoneNumber: "", email: "", externalId: ""},
                provider: {id: 0, firstName: "", lastName: "", titleCode: "", npi: ""},
                group: {id: 0, name: "", addr1: "", addr2: "", city: "", state: "", zip: "", fax: "", email: "", phone: ""},
                attorney: {id: 0, firstName: "", lastName: "", titleCode: "", npi: ""},
                attorneyGroup: {id: 0, name: "", addr1: "", addr2: "", city: "", state: "", zip: "", fax: "", email: "", phone: ""},
            }, () => {
            const formData = new FormData();
            this.state.selectedFiles.forEach((file, index) => {
                formData.append(`files`, file);
            });

            // Use fetch directly for FormData upload
            fetch('/web-api/referrals/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.context.token}`,
                    "Accept": "application/json"
                },
                body: formData
            })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Upload failed');
                })
                .then(data => {
                    // Clear file input
                    document.getElementById('file-input').value = '';
                    // start polling for results based on the key returned in the json response
                    this.setState({ selectedFiles: [], jobId: data.jobId }, () => {
                        window.setTimeout(this.pollResults, 1000)
                    });
                })
                .catch(error => {
                    console.error('Error uploading files:', error);
                    this.setState({ uploading: false });
                    this.context.toast('Error', 'Failed to upload files. Please try again.');
                });
        });

    };

    pollResults = () => {
        if (this.state.jobId && !this.state.jobResults) {
            this.context.apiRequest('GET', `/referrals/upload/${this.state.jobId}/status`)
                .then(resp => {
                    if (resp && resp.status) {
                        if (resp.status !== 'PENDING' && resp.status !== 'PROCESSING') {
                            this.context.apiRequest('DELETE', `/referrals/upload/${this.state.jobId}`)
                                .then(() => {
                                    console.log('Deleted job');
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                        const referralDocumentTypes = ['REFERRAL_STANDARD', 'REFERRAL_LIEN', 'REFERRAL_WORKERS_COMP'];
                        const isReferralDocument = !resp.documentType || referralDocumentTypes.includes(resp.documentType);
                        if (resp.status === 'COMPLETE' && isReferralDocument) {
                            console.log('Got results');
                            this.setState({ uploading: false, jobResults: resp }, this.useSuggestedProviders);
                        } else if (resp.status === 'PENDING' || resp.status === 'PROCESSING') {
                            // poll again in 1 sec
                            window.setTimeout(this.pollResults, 1000);
                        } else if (resp.status === 'FAILED') {
                            this.setState({ uploading: false, jobId: null, jobResults: null });
                            this.context.toast('Error', 'Upload failed. Please try again.');
                        } else if (resp.status === 'MERGED') {
                            this.setState({ uploading: false, jobId: null, jobResults: null });
                            this.context.toast('Notification', 'This upload was merged with an existing referral upload.');
                        } else if ((resp.documentType && resp.documentType !== 'NON_CLINICAL') || resp.status === 'RECORDED' || resp.status === 'UNMATCHED') {
                            const documentMessage = resp.status === 'RECORDED'
                                ? 'This document has been added to the patient\'s document summaries.'
                                : 'No matching patient could be found. Make sure the document contains the patient\'s first name, last name and date of birth, and that the patient exists in SMART.';
                            this.setState({ uploading: false, jobId: null, jobResults: { documentMessage } });
                        } else if (resp.documentType === 'NON_CLINICAL' || resp.status === 'IGNORED') {
                            this.setState({
                                uploading: false,
                                jobId: null,
                                jobResults: { documentMessage: 'This document was not clinical and was ignored.' }
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.setState({ uploading: false, jobId: null, jobResults: null });
                    this.context.toast('Error', 'Request failed. Please try again.');
                });
        }
    }

    submit = (e) => {
        e.preventDefault();
        this.handleUpload();
    };

    referringProviderReady = () => {
        const provider = this.state.provider;
        if (!provider) {
            return false;
        }
        if ((provider.id || provider.providerId || 0) > 0) {
            return true;
        }
        const firstName = (provider.firstName || '').trim();
        const lastName = (provider.lastName || '').trim();
        return firstName.length > 0 && lastName.length > 0;
    };

    ok = () => {
        if (!this.referringProviderReady()) {
            return;
        }
        if (this.state.jobResults) {
            const r = this.state.jobResults.result;
            const category = r.referralCategory || 'STANDARD';
            const ignored = this.state.specialtyInfoIgnored;
            const payload = {
                patient: this.state.patient,
                provider: this.state.provider,
                group: this.state.group,
                attorney: this.state.attorney,
                attorneyGroup: this.state.attorneyGroup,
                icd10s: r.referralIcd10s,
                conditions: r.referralConditions,
                otherIcd10s: r.otherIcd10s,
                otherConditions: r.otherConditions,
                medications: r.medications,
                jobId: this.state.jobId,
                referralCategory: category,
                visitSubtypeCode: visitSubtypeForCategory(category),
                lienDetails: ignored ? null : limitSpecialtyDetails('LIEN', this.state.lienDetails),
                workersCompDetails: ignored ? null : limitSpecialtyDetails('WORKERS_COMP', this.state.workersCompDetails),
            }
            this.setState({ posting: true });
            this.context.apiRequest('POST', '/referrals/upload/complete', payload)
                .then(resp => {
                    if (resp && resp.data) {
                        this.props.history.push(`/patients/${resp.data.patientId}?referralId=${resp.data.referralId}`);
                        this.props.onComplete();
                    }
                    this.setState({ posting: false });
                })
                .catch(err => {
                    console.error(err);
                    this.setState({ posting: false });
                    this.context.toast('Error', 'Failed to complete referral upload. Please try again.');
                });
        }
    };

    onCancel = () => {
        this.setState({ selectedFiles: [] });
        this.props.onCancel();
    };

    openCancelModal = () => {
        this.setState({ showCancelModal: true });
    };

    closeCancelModal = () => {
        this.setState({ showCancelModal: false });
    };

    submitCancelModal = (status, dismissReason) => {
        const payload = { status };
        if (status === 'DISMISSED') {
            payload.dismissReason = dismissReason;
        }
        this.context.apiRequest('POST', `/referrals/pendingUploads/${this.state.jobId}/status`, payload)
            .then(() => {
                this.setState({ showCancelModal: false }, () => {
                    this.reset();
                    if (this.props.onComplete) {
                        this.props.onComplete();
                    }
                });
            })
            .catch(err => {
                console.error(err);
                this.context.toast('Error', 'Failed to update referral upload status. Please try again.');
            });
    };

    altPatientSelected = (patient) => {
        this.setState({patient, showAltPatientModal: false});
    }

    useSuggestedProviders = () => {
        const r = this.state.jobResults ? this.state.jobResults.result : null;
        if (r) {
            let matches = r.providerMatches;
            let groupMatches = r.groupMatches;
            let patientMatches = r.patientMatches;

            if (matches && matches.length > 0) {
                let provider = matches[0];
                let group = groupMatches && groupMatches.length > 0 ? groupMatches[0] : null;
                this.setState({provider, group});
            }

            matches = r.attorneyMatches;
            groupMatches = r.attorneyGroupMatches;

            if (matches && matches.length > 0) {
                let attorney = matches[0];
                let attorneyGroup = groupMatches && groupMatches.length > 0 ? groupMatches[0] : null;
                this.setState({attorney, attorneyGroup});
            }

            if (patientMatches && patientMatches.length > 0) {
                this.setState({patient: patientMatches[0]});
            }

            this.setState({
                lienDetails: limitSpecialtyDetails('LIEN', r.lienDetails),
                workersCompDetails: limitSpecialtyDetails('WORKERS_COMP', r.workersCompDetails),
            });
        }
    }

    specialtyFieldChanged = (section, fname, val) => {
        this.setState(prev => ({
            [section]: {...prev[section], [fname]: val}
        }));
    }

    ignoreSpecialtyInfo = () => {
        this.setState({specialtyInfoIgnored: true});
    }

    undoIgnoreSpecialtyInfo = () => {
        this.setState({specialtyInfoIgnored: false});
    }

    providerOverride = (provider, group) => {
        this.setState({provider, group, showAltProviderModal: false});
    }

    attorneyOverride = (attorney, attorneyGroup) => {
        this.setState({attorney, attorneyGroup, showAltAttorneyModal: false});
    }

    fileNameFromUrl = (url) =>
        decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));

    render() {
        const r = this.state.jobResults ? this.state.jobResults.result : null;
        const documentMessage = this.state.jobResults ? this.state.jobResults.documentMessage : null;
        const provider = this.state.provider;
        const group = this.state.group;
        const attorney = this.state.attorney;
        const attorneyGroup = this.state.attorneyGroup;
        const pt = this.state.patient;

        return <Container>
                <ReferralUploadProviderPicker
                    providerType={"Provider"}
                    show={this.state.showAltProviderModal}
                    onCancel={() => this.setState({showAltProviderModal: false})}
                    onSelect={this.providerOverride} />

                <ReferralUploadProviderPicker
                    providerType={"Attorney"}
                    show={this.state.showAltAttorneyModal}
                    onCancel={() => this.setState({showAltAttorneyModal: false})}
                    onSelect={this.attorneyOverride} />

                <ReferralUploadPatientPicker show={this.state.showAltPatientModal}
                    onCancel={() => this.setState({showAltPatientModal: false})}
                    onSelect={this.altPatientSelected}/>

                <ReferralUploadCancelModal
                    show={this.state.showCancelModal}
                    onCancel={this.closeCancelModal}
                    onSubmit={this.submitCancelModal}/>

                <h3>Upload External Documents</h3>
                <Form.Text className="text-muted">
                    Upload any external patient-related documents: referrals, medical records, test results, etc.
                </Form.Text>
                {this.state.showUpload && (
                <Form noValidate validated={this.state.validated} onSubmit={this.submit}>
                    <FormGroup as={Row} controlId="file-input" className="mt-5">
                        <Col sm={12} md={6}>
                            <Form.File
                                required
                                onChange={this.handleFileSelection}
                                id={"file-input"}
                                label={"Select Files"}
                                custom
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.tif,.tiff"
                                multiple
                            />
                            <Form.Text className="text-muted">
                                Note: When uploading multiple files, all files must be for the same patient.
                            </Form.Text>
                        </Col>
                    </FormGroup>
                </Form>
                )}
                    {this.state.selectedFiles.length > 0 && (
                        <FormGroup as={Row}>
                            <Col sm={12} md={6}>
                                <Row>
                                    <Col sm={12}>
                                        <FormLabel>Selected Files:</FormLabel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        {this.state.selectedFiles.map((file, index) => (
                                            <Badge pill variant={"dark"} key={"f-"+index} className={"mr-2 p-2"}>
                                                <span className="mr-2">{file.name}</span>
                                                <Glyph name="x-lg" className={"clickable"} onClick={() => this.removeFile(index)}/>
                                            </Badge>
                                        ))}
                                    </Col>
                                </Row>
                            </Col>
                        </FormGroup>
                    )}

                    {this.state.showUpload && (
                    <FormGroup>
                        <Button
                            variant="secondary"
                            onClick={this.handleUpload}
                            disabled={this.state.selectedFiles.length === 0 || this.state.uploading}
                        >
                            <Glyph name="upload" className="mr-2" />
                            {this.state.uploading ? 'Uploading...' : 'Upload'}
                        </Button>
                    </FormGroup>
                    )}
                    {
                        (this.state.uploading || r || documentMessage) ?
                        <Card className="mb-4">
                            <Card.Header>
                                <Row>
                                    <Col sm={12}>
                                        <h5>Upload Results {r && r.pagesAnalyzed ? `(${r.pagesAnalyzed} pages analyzed)` : ``}</h5>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                {documentMessage ? <p className="mb-0">{documentMessage}</p> :
                                <SpinnerWrapper visible={!r}>
                                    {
                                        r ? <Container>
                                            {r.files && r.files.length > 0 && <Row className="mb-4">
                                                <Col sm={12}>
                                                    <h4>Original Documents</h4>
                                                    {r.files.map((url, i) => (
                                                        <Row key={`orig-doc-${i}`}>
                                                            <Col className="ml-2">
                                                                <a href={url} target="_blank" rel="noopener noreferrer">
                                                                    {this.fileNameFromUrl(url)}
                                                                </a>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                </Col>
                                            </Row>}
                                            <Row>
                                                <Col md={6}>
                                                    <h4>Data Extracted from Document(s)</h4>
                                                </Col>
                                                <Col md={6}>
                                                    <h4>Referral Info</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <FormLabel>Patient:</FormLabel>
                                                    <Table striped size={"sm"}>
                                                        <tbody>
                                                        <tr>
                                                            <td>Name:</td>
                                                            <td>{r.patient.firstName} {r.patient.lastName} {r.patient.suffix || ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>DOB:</td>
                                                            <td>{r.patient.dob || "Not Found"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Phone:</td>
                                                            <td>{r.patient.phone || "Not Found"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Email:</td>
                                                            <td>{r.patient.email || "Not Found"}</td>
                                                        </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                                <Col md={6}>
                                                    <Row>
                                                        <Col>
                                                            <FormLabel>Matching Patient</FormLabel>
                                                            {
                                                                pt ?
                                                                    <Table striped size={"sm"}>
                                                                        <tbody>
                                                                        <tr>
                                                                            <td>Name:</td>
                                                                            <td>{pt.name || "Not Found - was the patient registered?"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>DOB:</td>
                                                                            <td>{pt.dob ? moment(pt.dob).format("M/D/YYYY") : "Not Found"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Phone:</td>
                                                                            <td>{pt.phone || "Not Found"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Email:</td>
                                                                            <td>{pt.email || "Not Found"}</td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </Table> : <>No matching patient found.</>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <div className={"d-block text-right"}>
                                                        <small><a href={"#"} onClick={() => this.setState({showAltPatientModal: true})}>Override...</a></small>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className={"mt-4"}>
                                                <Col md={6}>
                                                    <FormLabel>Referring Provider:</FormLabel>
                                                    <Table striped size={"sm"}>
                                                        <tbody>
                                                        <tr>
                                                            <td>Name:</td>
                                                            <td>{r.referringProvider.firstName} {r.referringProvider.lastName} {r.referringProvider.titleCode || ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>NPI:</td>
                                                            <td>{r.referringProvider.npi || "Not Found"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Practice:</td>
                                                            <td>{r.referringProvider.practice.name}</td>
                                                        </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                                <Col sm={6}>
                                                    <div className={"d-block"}><FormLabel>Matching Provider:</FormLabel></div>
                                                    {
                                                        this.referringProviderReady() ?
                                                            <Table striped size={"sm"}>
                                                                <tbody>
                                                                <tr>
                                                                    <td>Name:</td>
                                                                    <td>{provider.firstName} {provider.lastName} {provider.titleCode || ""}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>NPI:</td>
                                                                    <td>{provider.npi || "Not Found"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Practice:</td>
                                                                    <td>{group && group.name ? group.name : "Not Found"}</td>
                                                                </tr>
                                                                </tbody>
                                                            </Table> : "No matching provider found."
                                                    }
                                                    <div className={"d-block text-right"}>
                                                        <small><a href={"#"} onClick={() => this.setState({showAltProviderModal: true})}>Override...</a></small>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <FormLabel>Attorney:</FormLabel>
                                                    {
                                                        r.referringAttorney ? <Table striped size={"sm"}>
                                                            <tbody>
                                                            <tr>
                                                                <td>Name:</td>
                                                                <td>{r.referringAttorney.firstName} {r.referringAttorney.lastName} {r.referringAttorney.suffix || ""}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Practice:</td>
                                                                <td>{r.referringAttorney.practice && r.referringAttorney.practice.name ? r.referringAttorney.practice.name : "None Found"}</td>
                                                            </tr>
                                                            </tbody>
                                                        </Table>
                                                            : <Row><Col>No attorney detected.</Col></Row>
                                                    }
                                                </Col>
                                                <Col sm={6}>
                                                    <div className={"d-block"}><FormLabel>Matching Attorney:</FormLabel></div>
                                                    {
                                                        attorney ?
                                                            <Table striped size={"sm"}>
                                                                <tbody>
                                                                <tr>
                                                                    <td>Name:</td>
                                                                    <td>{attorney.firstName} {attorney.lastName} {attorney.titleCode || ""}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Practice:</td>
                                                                    <td>{attorneyGroup && attorneyGroup.name ? attorneyGroup.name : "Not Found"}</td>
                                                                </tr>
                                                                </tbody>
                                                            </Table> : "No matching attorney found."
                                                    }
                                                    <div className={"d-block text-right"}>
                                                        <small><a href={"#"} onClick={() => this.setState({showAltAttorneyModal: true})}>Override...</a></small>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={8}>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <FormLabel>Symptoms/Reasons for Referral</FormLabel>
                                                            <br/><small className={"text-secondary"}>(Can be edited after referral is created)</small>
                                                            <br/><small><u>Primary:</u></small><br/>
                                                            {
                                                                (r.referralIcd10s && r.referralIcd10s.length > 0)
                                                                    || (r.referralConditions && r.referralConditions.length) > 0 ? <Table striped borderless size={"sm"}>
                                                                    <thead>
                                                                    <tr>
                                                                        <th className={"w-25"}>Code</th>
                                                                        <th>Description</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                        r.referralIcd10s && r.referralIcd10s.map((i,j) => <tr key={`ricd-${j}`}>
                                                                            <td>{i.code}</td>
                                                                            <td>{i.description}</td>
                                                                        </tr>)
                                                                    }
                                                                    {
                                                                        r.referralConditions && r.referralConditions.map((c,i) => <tr key={`rc-${i}`}>
                                                                            <td></td>
                                                                            <td>{c}</td>
                                                                        </tr>)
                                                                    }
                                                                    </tbody>

                                                                </Table> : "No primary symptoms/conditions found."
                                                            }
                                                                <br/><small><u>Other:</u></small><br/>
                                                                {
                                                                    (r.otherIcd10s && r.otherIcd10s.length > 0)
                                                                    || (r.otherConditions && r.otherConditions.length) > 0 ? <Table striped borderless size={"sm"}>
                                                                        <thead>
                                                                        <tr>
                                                                            <th className={"w-25"}>Code</th>
                                                                            <th>Description</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {
                                                                            r.otherIcd10s && r.otherIcd10s.map((i,j) => <tr key={`oicd-${j}`}>
                                                                                <td>{i.code}</td>
                                                                                <td>{i.description}</td>
                                                                            </tr>)
                                                                        }
                                                                        {
                                                                            r.otherConditions && r.otherConditions.map((c,i) => <tr key={`oc-${i}`}>
                                                                                <td></td>
                                                                                <td>{c}</td>
                                                                            </tr>)
                                                                        }
                                                                        </tbody>

                                                                    </Table> : "No secondary symptoms/conditions found."
                                                                }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <ReferralUploadSpecialtySection
                                                referralCategory={r.referralCategory}
                                                lienDetails={this.state.lienDetails}
                                                workersCompDetails={this.state.workersCompDetails}
                                                onChange={this.specialtyFieldChanged}
                                                ignored={this.state.specialtyInfoIgnored}
                                                onIgnore={this.ignoreSpecialtyInfo}
                                                onUndo={this.undoIgnoreSpecialtyInfo}
                                            />
                                            <Row>
                                                <Col sm={12} className={"text-right"}>
                                                    <Button variant="secondary" onClick={this.openCancelModal} disabled={this.state.posting}>Cancel</Button>
                                                    <Button className={"ml-2"} variant="dark" disabled={this.state.patient === null || this.state.patient.id <= 0 || !this.referringProviderReady() || this.state.posting} onClick={this.ok}><SpinnerWrapper size="sm" visible={this.state.posting}>OK</SpinnerWrapper></Button>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                        </Container> : null
                                    }
                                </SpinnerWrapper>}
                            </Card.Body>
                        </Card> : <></>
                    }
                <Row><Col>&nbsp;</Col></Row> 
            </Container>

    }
}

export default withRouter(ReferralUpload);
